import { render, staticRenderFns } from "./ContselfStatus.vue?vue&type=template&id=0aba68f8&"
import script from "./ContselfStatus.vue?vue&type=script&lang=js&"
export * from "./ContselfStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports